export const inspectRegExp = (value) => value.toString()
